export default __webpack_public_path__ + "static/media/ketopopcorn-wide@2x.ea9da484.jpg";